import { Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss'
})
export class HeaderComponent {
  @Output() showMenu = new EventEmitter();

  toggleMenu() {
    this.showMenu.emit();
  }

  scrollToFooter() {
    const footer = document.getElementById('footer');

    footer?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
}
